
//Component colors
export const componentColors = {
  PRIMARY: 'primary',
  MUTED: 'muted',
  LIGHT: 'light',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
}

//Component sizes
export const componentSizes = {
  XS: 'xs',
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl',
  XXL: 'xxl',
  XXXL: 'xxxl',
}
